import * as React from 'react';
import Dropdown from '../Dropdown';
import { defaultLocale } from 'dibs-intl/exports/constants';
import { useIntl, defineMessages } from 'dibs-react-intl';
import SV from 'server-vars';
import styles from './styles/CountrySelector.scss';

const intlCountries = defineMessages({
    'en-US': {
        id: 'dbl.country.usa',
        defaultMessage: 'United States',
    },
    'en-GB': {
        id: 'dbl.country.uk',
        defaultMessage: 'United Kingdom',
    },
});

const messages = defineMessages({
    label: {
        id: 'dbl.Footer.CountryDropdown.label',
        defaultMessage: 'Country',
    },
});

type IntlLangKeys = keyof typeof intlCountries;
type SVLocale = string | null | undefined;
function isIntlKey(locale: unknown): locale is IntlLangKeys {
    return !!locale && typeof locale === 'string' && Object.keys(intlCountries).includes(locale);
}

const CountrySelector: React.FC<{ isClient?: boolean }> = ({ isClient }) => {
    const intl = useIntl();

    function handleCountryChange(linkToRedirect: string): void {
        const { location } = window;
        location.assign(linkToRedirect);
    }

    function getCountries(): { key: string; value: string }[] {
        const defaultDomainsLinks = SV.get('defaultDomainsLinks');
        const domains = isClient ? SV.get('domainLinks') : defaultDomainsLinks;
        const domainLinks = domains || defaultDomainsLinks || [];

        return domainLinks.map((countryLink: { hrefLang?: string; href?: string }) => {
            let hrefLang = countryLink?.hrefLang;
            if (hrefLang === 'en') {
                hrefLang = defaultLocale;
            }
            return {
                value: countryLink?.href,
                key: isIntlKey(hrefLang) ? intl.formatMessage(intlCountries[hrefLang]) : '',
            };
        });
    }

    if (isClient) {
        const countries = getCountries();
        const svLocale: SVLocale = SV.get('locale');
        const countryMessage = isIntlKey(svLocale)
            ? intlCountries[svLocale]
            : intlCountries[defaultLocale];
        return (
            <Dropdown
                dataTn="footer-country-dropdown"
                selectedOption={intl.formatMessage(countryMessage)}
                options={countries}
                onChange={handleCountryChange}
                dropdownClass={styles.dropdown}
                label={intl.formatMessage(messages.label)}
            />
        );
    } else {
        return null;
    }
};

export default CountrySelector;
